import { createFileRoute } from '@tanstack/react-router';
import { Navbar } from '@/components/sections/navbar';
import { SiteFooter } from '@/components/sections/site-footer';
import { ScrollReveal } from '@/components/ui/scroll-reveal';
import { useLang } from '@/lib/LanguageContext';
import { ta } from '@/lib/i18n';
import { t } from '@/lib/translations';

const STORAGE_KEY = 'oceanne-cookie-consent';

export function ConfidentialitePage() {
  const { lang } = useLang();
  const text = ta(t.privacy, lang);
  const cookies = ta(t.cookies, lang);

  const sections = [
    { title: text.s1_title, body: text.s1_body },
    { title: text.s2_title, body: text.s2_body },
    { title: text.s3_title, body: text.s3_body },
    { title: text.s4_title, body: text.s4_body },
    { title: text.s5_title, body: text.s5_body },
    { title: text.s6_title, body: text.s6_body },
    { title: text.s7_title, body: text.s7_body },
    { title: text.s8_title, body: text.s8_body }
  ];

  const handleRevoke = () => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(STORAGE_KEY);
    window.location.reload();
  };

  return (
    <div className="flex min-h-[100dvh] flex-col bg-background text-foreground">
      <Navbar />
      <main className="flex-grow py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-5 md:px-8">
          <div className="mb-12 md:mb-16">
            <ScrollReveal as="span" className="mb-4 block font-display text-base italic tracking-wide text-secondary">
              {text.eyebrow}
            </ScrollReveal>
            <h1 className="mb-3 font-display text-3xl leading-[1.2] text-balance text-foreground md:text-5xl">
              {text.title}
            </h1>
            <ScrollReveal delay={200} as="p" className="mb-6 font-sans text-sm italic text-muted-foreground">{text.last_updated}</ScrollReveal>
            <ScrollReveal delay={300} as="p" className="font-sans text-base leading-relaxed text-pretty hyphens-auto text-muted-foreground">{text.intro}</ScrollReveal>
          </div>
          <div>
            {sections.map((sec, i) => (
              <ScrollReveal
                key={i}
                as="section"
                delay={(Math.min((i % 5) * 100, 400)) as 0 | 100 | 200 | 300 | 400}
                className={`pb-8 ${i < sections.length - 1 ? 'mb-8 border-b border-border/40' : ''}`}
              >
                <h2 className="mb-3 font-display text-2xl text-balance text-foreground md:text-3xl">{sec.title}</h2>
                <p className="font-sans text-base leading-relaxed text-pretty hyphens-auto text-muted-foreground">{sec.body}</p>
              </ScrollReveal>
            ))}
          </div>
          <div className="mt-12 border-t border-border/40 pt-8">
            <button
              type="button"
              onClick={handleRevoke}
              aria-label={cookies.revoke_link}
              className="rounded-md border border-border px-4 py-2 text-sm font-bold uppercase tracking-widest hover:bg-muted"
            >
              {cookies.revoke_link}
            </button>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

export const Route = createFileRoute('/confidentialite')({ component: ConfidentialitePage });
